import { createUseRBAC } from 'features/Auth/utils/hooks/useRBAC'

export const ModifierConnectionPageRBAC = {
  pageID: '002dcd4d93fbb1b271da1a0b7b5d0b86',
  elementID: {
    BtnEditHubunganModifier: '7ddf445a08ffe95aaad6da90dc832fe3',
  },
} as const

export const useRBACModifierConnectionPage = createUseRBAC(ModifierConnectionPageRBAC.elementID)

export type UseRBACModifierConnectionPageType = ReturnType<typeof useRBACModifierConnectionPage>
